import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types';

const CustomCheckbox = ({ input, label, disabled }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          checked={input.value ? true : false}
          onChange={input.onChange}
          disabled={disabled}
          labelStyle={{ color: 'white' }}
          iconStyle={{ fill: 'white' }}
          color="primary"
        />
      }
      label={label}
    />
  </div>
);

CustomCheckbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default CustomCheckbox;
